import { ControlledRadioGroup } from '@if/mui'
import { Chip } from '@mui/material'
import { EPromotionMode } from '@src/data/types/Constants'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { MerchantPromotionFormValues } from './tabs/MerchantPromotionTab'

interface Props {
  control: Control<MerchantPromotionFormValues>
  name: 'promotionMode'
  onChange?: (value: EPromotionMode) => void
  disabled?: boolean
}

/**
 * The mutually-exclusive Preconfigured / Custom promotion toggle. Bound to a form field so a
 * mode change marks the promotion tab dirty (driving the MultiFormTabs Save/dirty-guard).
 */
const PromotionModeSelector = ({ control, name, onChange, disabled }: Props) => {
  const { t } = useTranslation()

  return (
    <ControlledRadioGroup
      control={control}
      name={name}
      variant="card"
      onChange={onChange}
      disabled={disabled}
      label={
        <>
          {t('merchant.promotionMode.title')}
          {/* span so the chip nests validly inside the label typography */}
          <Chip component="span" label={t('merchant.promotionMode.mutuallyExclusive')} size="small" sx={{ ml: 1 }} />
        </>
      }
      options={[
        {
          value: EPromotionMode.Preconfigured,
          title: t('merchant.promotionMode.preconfigured.title'),
          description: t('merchant.promotionMode.preconfigured.description'),
        },
        {
          value: EPromotionMode.Custom,
          title: t('merchant.promotionMode.custom.title'),
          description: t('merchant.promotionMode.custom.description'),
        },
      ]}
    />
  )
}

export default PromotionModeSelector
